import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDashboard = () => {
  return (
    <g>
      <path d="M0 9a8 8 0 0 1 15.996-.25L16 14a1 1 0 0 1-.998 1H1a1 1 0 0 1-1-1V9zm8.75-6.457v.906a.742.742 0 0 1-.75.734.745.745 0 0 1-.743-.634l-.007-.1v-.906c-.951.11-1.84.424-2.62.898l.5.562a.724.724 0 0 1-.071 1.037.762.762 0 0 1-.98.007L4 4.971l-.548-.614A6.508 6.508 0 0 0 1.9 6.75l.86.121c.41.058.695.43.636.831a.745.745 0 0 1-.747.631l-.101-.007-.998-.14c-.024.192-.04.387-.047.585l-.002.134.002.095-.004 4.499h12.999l-.003-4.732a6.545 6.545 0 0 0-.046-.58l-.994.139-.102.007a.745.745 0 0 1-.746-.63.735.735 0 0 1 .536-.811l.1-.02.856-.122a6.505 6.505 0 0 0-1.543-2.385l-.543.606-.079.076a.762.762 0 0 1-.979-.007.724.724 0 0 1-.137-.95l.067-.087.496-.555a6.46 6.46 0 0 0-2.632-.905zm.799 2.75a.75.75 0 0 1 .49.855l-.028.099-.606 1.746A2.25 2.25 0 1 1 7.988 7.5l.606-1.746a.75.75 0 0 1 .955-.462zM8 9a.75.75 0 1 0 0 1.5A.75.75 0 0 0 8 9z" />
    </g>
  );
};

export default withIcon(IconDashboard);
